<template>
  <div class="user-territory">
    <div class="userTitle1">
      <span class="iconfont iconicon_huabanfuben">
        <img width="19px" src="../../static/img/home.svg" />
      </span>
      用户中心
    </div>
    <div class="userTitle2">
      <span>个人信息</span>
    </div>
    <el-row class="info">
      <div class="left">
        <svg
          width="80"
          height="72"
          viewBox="0 0 39 46"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.0155306 44.0711C0.00492573 44.149 -0.000260386 44.2276 1.00532e-05 44.3063V44.4325C0.012648 44.5835 0.0430235 44.7324 0.0909145 44.8759C0.20741 45.2049 0.42307 45.4897 0.708181 45.691C0.993292 45.8923 1.33382 46.0003 1.68285 46C2.41673 46 3.42998 45.3615 3.40338 44.53C3.40338 35.832 10.4163 29.0275 19.1165 29.0275C19.2207 29.0275 19.2207 25.8745 19.1165 25.8745C8.83102 25.859 0.434577 33.872 0.0155306 44.0711ZM29.3865 32.6992C32.6568 35.648 34.9117 39.7163 34.9117 44.5145C34.8851 45.3459 35.8983 45.9845 36.6324 45.9845C36.9814 45.9848 37.322 45.8769 37.6071 45.6756C37.8922 45.4743 38.1079 45.1896 38.2244 44.8606C38.272 44.7169 38.3028 44.5679 38.3153 44.4172V44.2908C38.3153 44.2123 38.3104 44.1336 38.2997 44.0555C38.1951 41.409 37.5345 38.8141 36.361 36.4396C35.1874 34.0651 33.5272 31.9642 31.4884 30.2736C29.7501 29.012 27.7546 31.227 29.3865 32.6992V32.6992Z"
            fill="#666666"
          />
          <path
            d="M19.1208 0C11.9757 0 6.18359 5.79215 6.18359 12.9372C6.18359 20.0823 11.9757 25.8745 19.1208 25.8745C26.2659 25.8745 32.058 20.0821 32.058 12.9372C32.058 5.79215 26.2659 0 19.1208 0V0ZM19.1208 22.6418C13.7623 22.6418 9.41845 18.2979 9.41845 12.9394C9.41845 7.58097 13.7623 3.23708 19.1208 3.23708C24.4793 3.23708 28.8232 7.58097 28.8232 12.9394C28.8232 18.2979 24.4793 22.6418 19.1208 22.6418Z"
            fill="#666666"
          />
        </svg>
      </div>
      <div class="right">
        <p class="rightp2">账号： {{ userInfo.name }}</p>
        <p class="rightp3">
          余额：￥{{ userInfo.totalBalance }}
          <i
            :class="['iconfont', 'el-icon-refresh', { annkrotate1: isRotate }]"
            @click="getuserMoney"
          ></i>
        </p>
      </div>
    </el-row>
    <div class="links">
      <router-link to="/user/notice"> <label></label>系统公告 </router-link>
      <router-link to="/user/modifyLoginPsw">
        <label></label>修改账号密码
      </router-link>
    </div>
    <div class="userTitle2">
      <span>快捷存取</span>
    </div>
    <el-row class="money">
      <router-link to="/user/deposit" class="left">
        <div class="top">
          <span>在线存款 ↓</span>
          快捷存款，到账及时
        </div>
        <div class="iconfont iconzengjia">
          <svg
            width="80"
            height="72"
            viewBox="0 0 46 46"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0)">
              <path
                d="M29.6469 23.023C30.5439 23.023 31.2799 22.287 31.2799 21.39C31.2799 20.493 30.5439 19.757 29.6469 19.757H24.6559V19.688L30.7509 13.34C31.3719 12.673 31.3719 11.638 30.7049 11.017C30.0609 10.396 29.0259 10.419 28.3819 11.063L23.1609 16.537L17.6409 11.04C16.9969 10.396 15.9619 10.396 15.3179 11.04C14.6739 11.684 14.6509 12.719 15.2949 13.363L21.3669 19.458V19.757H16.5139C15.6169 19.757 14.8809 20.493 14.8809 21.39C14.8809 22.287 15.6169 23.023 16.5139 23.023H21.3669V26.312H16.5139C15.6169 26.312 14.8809 27.048 14.8809 27.945C14.8809 28.842 15.6169 29.578 16.5139 29.578H21.3669V34.454C21.3669 35.351 22.1029 36.087 22.9999 36.087C23.8969 36.087 24.6329 35.351 24.6329 34.454V29.578H29.6239C30.5209 29.578 31.2569 28.842 31.2569 27.945C31.2569 27.048 30.5209 26.312 29.6239 26.312H24.6329V23.023H29.6469ZM44.3439 9.38402H32.2459C31.3259 9.38402 30.5899 8.64802 30.5899 7.72802C30.5899 6.80802 31.3259 6.07202 32.2459 6.07202H44.3439C45.2639 6.07202 45.9999 6.80802 45.9999 7.72802C45.9999 8.62502 45.2639 9.38402 44.3439 9.38402Z"
                fill="#ffffff"
              />
              <path
                d="M36.6621 13.731V1.656C36.6621 0.736 37.3981 0 38.3181 0C39.2381 0 39.9741 0.736 39.9741 1.656V13.754C39.9741 14.674 39.2381 15.41 38.3181 15.41C37.3981 15.387 36.6621 14.651 36.6621 13.731Z"
                fill="#ffffff"
              />
              <path
                d="M23 46C10.327 46 0 35.673 0 23C0 10.327 10.327 0 23 0V3.45C12.213 3.45 3.45 12.213 3.45 23C3.45 33.787 12.213 42.55 23 42.55C33.787 42.55 42.55 33.787 42.55 23H46C46 35.673 35.673 46 23 46Z"
                fill="#ffffff"
              />
              <path
                d="M42.5498 23C42.5498 23.4575 42.7315 23.8963 43.055 24.2198C43.3785 24.5433 43.8173 24.725 44.2748 24.725C44.7323 24.725 45.1711 24.5433 45.4946 24.2198C45.8181 23.8963 45.9998 23.4575 45.9998 23C45.9998 22.5425 45.8181 22.1038 45.4946 21.7803C45.1711 21.4568 44.7323 21.275 44.2748 21.275C43.8173 21.275 43.3785 21.4568 43.055 21.7803C42.7315 22.1038 42.5498 22.5425 42.5498 23V23Z"
                fill="#ffffff"
              />
              <path
                d="M21.2754 1.725C21.2754 2.1825 21.4571 2.62126 21.7806 2.94476C22.1041 3.26826 22.5429 3.45 23.0004 3.45C23.4579 3.45 23.8966 3.26826 24.2201 2.94476C24.5436 2.62126 24.7254 2.1825 24.7254 1.725C24.7254 1.2675 24.5436 0.828741 24.2201 0.505241C23.8966 0.181741 23.4579 0 23.0004 0C22.5429 0 22.1041 0.181741 21.7806 0.505241C21.4571 0.828741 21.2754 1.2675 21.2754 1.725V1.725Z"
                fill="#ffffff"
              />
            </g>
            <defs>
              <clipPath id="clip0">
                <rect width="46" height="46" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div>
        <div class="count">
          <p class="countp1">微信入款 支付宝入款</p>
          <p class="countp1">线上网银 银行转账</p>
          <p class="countp2">快捷入款通道</p>
        </div>
      </router-link>
      <router-link to="/user/creditCard" class="right">
        <div class="top">
          <span>在线取款 ↓</span>
          快捷取款，到账及时
        </div>
        <div class="iconfont iconjianshao">
          <svg
            width="80"
            height="72"
            viewBox="0 0 46 46"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0)">
              <path
                d="M29.6469 23.023C30.5439 23.023 31.2799 22.287 31.2799 21.39C31.2799 20.493 30.5439 19.757 29.6469 19.757H24.6559V19.688L30.7509 13.34C31.3719 12.673 31.3719 11.638 30.7049 11.017C30.0609 10.396 29.0259 10.419 28.3819 11.063L23.1609 16.537L17.6409 11.04C16.9969 10.396 15.9619 10.396 15.3179 11.04C14.6739 11.684 14.6509 12.719 15.2949 13.363L21.3669 19.458V19.757H16.5139C15.6169 19.757 14.8809 20.493 14.8809 21.39C14.8809 22.287 15.6169 23.023 16.5139 23.023H21.3669V26.312H16.5139C15.6169 26.312 14.8809 27.048 14.8809 27.945C14.8809 28.842 15.6169 29.578 16.5139 29.578H21.3669V34.454C21.3669 35.351 22.1029 36.087 22.9999 36.087C23.8969 36.087 24.6329 35.351 24.6329 34.454V29.578H29.6239C30.5209 29.578 31.2569 28.842 31.2569 27.945C31.2569 27.048 30.5209 26.312 29.6239 26.312H24.6329V23.023H29.6469ZM44.3439 9.38402H32.2459C31.3259 9.38402 30.5899 8.64802 30.5899 7.72802C30.5899 6.80802 31.3259 6.07202 32.2459 6.07202H44.3439C45.2639 6.07202 45.9999 6.80802 45.9999 7.72802C45.9999 8.62502 45.2639 9.38402 44.3439 9.38402Z"
                fill="#fff"
              />
              <path
                d="M23 46C10.327 46 0 35.673 0 23C0 10.327 10.327 0 23 0V3.45C12.213 3.45 3.45 12.213 3.45 23C3.45 33.787 12.213 42.55 23 42.55C33.787 42.55 42.55 33.787 42.55 23H46C46 35.673 35.673 46 23 46Z"
                fill="#fff"
              />
              <path
                d="M42.5498 23C42.5498 23.4575 42.7315 23.8963 43.055 24.2198C43.3785 24.5433 43.8173 24.725 44.2748 24.725C44.7323 24.725 45.1711 24.5433 45.4946 24.2198C45.8181 23.8963 45.9998 23.4575 45.9998 23C45.9998 22.5425 45.8181 22.1038 45.4946 21.7803C45.1711 21.4568 44.7323 21.275 44.2748 21.275C43.8173 21.275 43.3785 21.4568 43.055 21.7803C42.7315 22.1038 42.5498 22.5425 42.5498 23V23Z"
                fill="#fff"
              />
              <path
                d="M21.2754 1.725C21.2754 2.1825 21.4571 2.62126 21.7806 2.94476C22.1041 3.26826 22.5429 3.45 23.0004 3.45C23.4579 3.45 23.8966 3.26826 24.2201 2.94476C24.5436 2.62126 24.7254 2.1825 24.7254 1.725C24.7254 1.2675 24.5436 0.828741 24.2201 0.505241C23.8966 0.181741 23.4579 0 23.0004 0C22.5429 0 22.1041 0.181741 21.7806 0.505241C21.4571 0.828741 21.2754 1.2675 21.2754 1.725V1.725Z"
                fill="#fff"
              />
            </g>
            <defs>
              <clipPath id="clip0">
                <rect width="46" height="46" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div>
        <div class="count">
          <p class="countp1">首次取款：绑定银行卡</p>
          <p class="countp2">快捷取款通道</p>
        </div>
      </router-link>
    </el-row>
    <div class="userTitle2 hide">
      <span>消息中心</span>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      isRotate: false,
    };
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  methods: {
    getuserMoney() {
      this.isRotate = true;
      this.$nkhttp.getuserMoney(
        (res) => {
          if (res.code == 0) {
            this.$message.success("余额获取成功！");
          } else {
            this.$message.error(res.msg || "请求失败");
          }
          this.isRotate = false;
        },
        false,
        true
      );
    },
  },
};
</script>
<style lang="scss" scoped>
.user-territory {
  .info {
    .left {
      float: left;
      font-size: 80px;
      color: #b4b4b4;
      background: #efefef;
      padding: 10px;
      line-height: 1;
      border-radius: 10px;
      margin: 47px 27px 20px 62px;
    }
    .right {
      margin-top: 47px;
      text-align: left;
      font-size: 14px;
      .rightp1 {
        color: #73b7f1;
      }
      .rightp2 {
        margin: 15px 0;
        color: #666;
      }
      .rightp3 {
        margin: 15px 0;
        color: #c51e32;
        i {
          display: inline-block;
          color: #666;
          margin-left: 10px;
          cursor: pointer;
        }
      }
    }
  }
  .links {
    padding-left: 62px;
    padding-bottom: 47px;
    border-bottom: 1px solid #e6e6e6;
    a {
      margin-right: 50px;
      label {
        display: inline-block;
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background-color: #f43b5b;
        margin-right: 10px;
      }
    }
  }
  .money {
    color: #666;
    a {
      float: left;
      width: 350px;
      margin-left: 50px;
      .top {
        margin-top: 44px;
        float: left;
        width: 100%;
        border-bottom: 1px solid #f0f0f0;
        padding-bottom: 10px;
        span {
          font-size: 16px;
          color: #c51e32;
          margin-right: 35px;
          margin-left: 20px;
        }
      }
      .iconfont {
        float: left;
        font-size: 80px;
        color: #fff;
        background: #c51e32;
        padding: 10px;
        line-height: 1;
        border-radius: 10px;
        margin: 20px;
      }
      .count {
        float: left;
        font-size: 14px;
        margin-top: 20px;
        .countp1 {
          margin-bottom: 10px;
        }
        .countp2 {
          margin-top: 26px;
          color: #73b7f1;
        }
      }
      &.right {
        .top {
          span {
            color: #ff9835;
          }
        }
        .iconfont {
          background: #ff9835;
        }
      }
    }
  }
}
</style>